<template>
  <div id="app">
    <!-- DIALOGO DE LOADING -->
    <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }">
      <ProgressBar mode="indeterminate" style="height: 0.5em" />
      <span>{{ loadingMensaje }}</span>
    </Dialog>

    <div>
      <Toolbar id="border" class="pl-0 pt-2 pr-0 border" style="background: #ff6699;" v-if="logueado">
        <template #start>
          <i @click="visibleLeft = true" style="font-size: 25px; cursor: pointer" class="ml-4 mr-4 pi pi-bars"></i>
          <h4>{{ $store.state.usuario.empresa }}</h4>
        </template>
        <template #end>
          <h4>{{ $store.state.usuario.rfc }}</h4>
          <div type="button" @click="toggle">
            <Avatar style="cursor: pointer" type="button" icon="pi pi-user" class="ml-5 mr-5" size="large" shape="circle"
              aria-haspopup="true" aria-controls="overlay_tmenu" />
          </div>
          <TieredMenu id="overlay_tmenu" ref="menu" :model="itemsSalir" :popup="true" />
        </template>
      </Toolbar>
      <Sidebar :visible.sync="visibleLeft" :showCloseIcon="false" :baseZIndex="1000">
        <div @click="inicio()" style="cursor: pointer">
          <img src="../src/assets/logo_contago_erp.png" height="70" />
        </div>
        <ProgressBar :value="100" style="height: 0.3em" />
        <PanelMenu :model="items" />
      </Sidebar>
    </div>

    <!-- <MegaMenu v-if="logueado" :model="items" /> -->

    <router-view />
    <div id="footer" class="footer"></div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: false,
      loadingMensaje: "",
      nombreUsuario: "",
      visibleLeft: false,
      itemsSalir: [
        {
          label: "Configuracion",
          icon: "pi pi-fw pi-cog",
          command: (event) => {
            this.configuracion();
          },
        },
        {
          separator: true,
        },
        {
          label: "Salir",
          icon: "pi pi-fw pi-power-off",
          command: (event) => {
            this.salir();
          },
        },
      ],

      items: [
        {
          label: "Nóminas",
          icon: "mdi mdi-account-cash",
          to: "/ListaNomina",
          command: () => {
            this.visibleLeft = false;
          },
        },
        {
          label: "Trabajadores",
          icon: "mdi mdi-account-hard-hat-outline",
          to: "/ListaTrabajadores",
          command: () => {
            this.visibleLeft = false;
          },
        },
        {
          label: "Conceptos",
          icon: "mdi mdi-order-bool-descending",
          to: "/ListaConceptos",
          command: () => {
            this.visibleLeft = false;
          },
        },
        {
          label: "Reportes",
          icon: "mdi mdi-file-chart",
          to: "/Reportes",
          command: () => {
            this.visibleLeft = false;
          },
        },
      ],
    };
  },
  computed: {
    logueado() {
      return this.$store.state.usuario;
    },
    
    obtieneEmpresa() {
      return this.$store.state.usuario.empresa;
    },
    
    obtieneUsuario() {
      return this.$store.state.usuario.nombre;
    },

    esAdministrador() {
      return (
        this.$store.state.usuario &&
        this.$store.state.usuario.rol == "Administrador"
      );
    },
    
    Usuario() {
      return this.$store.state.usuario.rol;
    },
    
    usuarioVentas() {
      return this.$store.state.usuarioVentasStore
    }
  },
  mounted() {

this.obtieneToken();

},
  created() {
    this.$store.dispatch("autoLogin");
  },
  methods: {
    obtieneToken() {
      const cookie = document.cookie;
      const cookieArray = cookie.split('; ');
      let token = null;

      for (let i = 0; i < cookieArray.length; i++) {
        const cookieItem = cookieArray[i].split('=');
        if (cookieItem[0] === 'seguroContago') {
          token = cookieItem[1];
          this.$store.dispatch("guardarToken", token);
          break;
        }
      }
      
      this.$store.dispatch("autoLogin");

      // console.log('2', token);
    },

    toggle(event) {
      this.$refs.menu.toggle(event);
    },

    inicio() {
      this.$router.push({ name: "Home" }), (this.visibleLeft = false);
    },

    configuracion() {
      this.$router.push({ name: "Configuracion" });
      let empresa = {
        logo: {
          extencion: '',
          base64: '',
        },
        idEmpresa: 0,
        rfc: '',
        domicilioFiscal: '',
        nombre: '',
        regimenFiscal: {}
      }
      this.$store.state.empresaStore = { ...empresa }

    },

    async salir() {
      this.loading = true;
      this.loadingMensaje = "Cerrando Sesión...";
      let respuesta;
      try {
        respuesta = await axios.put(
          "https://api-framework.contago.com.mx/api/Usuarios/actualizaSesion/" +
          this.$store.state.usuario.nombre +
          "/INACTIVA"
        );
        this.$store.dispatch("salir");

        //INICIALIZAMOS LOS CATALOGOS
        this.$store.state.trabajadoresStore = [];
        this.$store.state.reporteMilDet = {};
        this.$store.state.listPuestosStore = []
        this.$store.state.listPuestosStore = []
        this.$store.state.reporteMilDet = []
        this.$store.state.listNominaStore = []
        this.$store.state.nominaGuardada = null
        this.$store.state.listNominaGuardada = null
        this.$store.state.empresaStore = null

        this.$store.state.percepcionesStore = null;
        this.$store.state.deduccionesStore = null;
        this.$store.state.otrosPagosStore = null;

      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
  },
};
</script>
<style>
.mdi:before, .mdi-set {
    font-size: 30px;
}
.p-sidebar .p-sidebar-header {
  padding: 0rem;
}

.p-sidebar .p-sidebar-content {
  padding: 0rem;
}

.p-panelmenu .p-panelmenu-header>a {
  padding: 1.5rem;
  border: 0 none;
  color: rgba(0, 0, 0, 0.87);
  background: #ffffff;
  font-weight: 400;
  border-radius: 4px;
  transition: none;
}

.p-panelmenu .p-panelmenu-header>a .p-panelmenu-icon {
  margin-right: 0.5rem;
}

.p-panelmenu .p-panelmenu-header>a .p-menuitem-icon {
  margin-right: 0.5rem;
}

.p-panelmenu .p-panelmenu-header>a:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}

.p-panelmenu .p-panelmenu-header:not(.p-highlight):not(.p-disabled)>a:hover {
  background: #BBDEFB;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.87);
}

.p-panelmenu .p-panelmenu-header.p-highlight {
  margin-bottom: 0;
}

.p-panelmenu .p-panelmenu-header.p-highlight>a {
  background: #BBDEFB;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.87);
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.p-panelmenu .p-panelmenu-header.p-highlight:not(.p-disabled)>a:hover {
  border-color: transparent;
  background: #BBDEFB;
  color: rgba(0, 0, 0, 0.87);
}

.p-panelmenu .p-panelmenu-content {
  padding: 0.5rem 0;
  border: 0 none;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 0;
  border-top: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link {
  padding: 1rem 1rem;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0;
  transition: none;
  user-select: none;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-menuitem-text {
  color: rgba(0, 0, 0, 0.87);
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-menuitem-icon {
  color: rgba(0, 0, 0, 0.6);
  margin-right: 0.5rem;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-submenu-icon {
  color: rgba(0, 0, 0, 0.6);
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover {
  background: #E3F2FD;

}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: rgba(0, 0, 0, 0.87);
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: rgba(0, 0, 0, 0.6);
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: rgba(0, 0, 0, 0.6);
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-panelmenu-icon {
  margin-right: 0.5rem;
}

.p-panelmenu .p-panelmenu-content .p-submenu-list:not(.p-panelmenu-root-submenu) {
  padding: 0 0 0 1rem;
}

.p-panelmenu .p-panelmenu-panel {
  margin-bottom: 0;
}

.p-panelmenu .p-panelmenu-panel .p-panelmenu-header>a {
  border-radius: 0;
}

.p-panelmenu .p-panelmenu-panel .p-panelmenu-content {
  border-radius: 0;
}

.p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header>a {
  border-top: 0 none;
}

.p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header:not(.p-highlight):not(.p-disabled):hover>a,
.p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header:not(.p-disabled).p-highlight:hover>a {
  border-top: 0 none;
}

.p-panelmenu .p-panelmenu-panel:first-child .p-panelmenu-header>a {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.p-panelmenu .p-panelmenu-panel:last-child .p-panelmenu-header:not(.p-highlight)>a {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.p-panelmenu .p-panelmenu-panel:last-child .p-panelmenu-content {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  margin: 0px;
  width: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

.border {
  /* border-top: 3px; */
  background: #ff6699;
  height: 60px;
}

.footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  height: 20px;
  width: 100%;
  background: #ff6699;
}

.p-toolbar {
  background: #ff6699;
  padding: 0.5rem;
  border-radius: 0px;
  margin: 0px;

}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  margin: 0px;
  width: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}


.p-menu {
  padding: 0.5rem 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  /* border: 1px solid #e5e5e5; */
  border-radius: 4px;
  /* width: 12.5rem; */
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

.p-tieredmenu .p-menuitem-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  text-decoration: none;
  overflow: hidden;
  position: relative;
  padding: 0.75rem 1.25rem;
  color: #000000;
  border-radius: 0;
  transition: box-shadow 0.2s;
  user-select: none;
}

.p-tieredmenu .p-menuitem-text {
  line-height: 1;
  padding-left: 10px;
}
</style>
